import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PopupModal, CloseButton, PopupBody, PopupFooter, PopupModalContainer, BackButton } from "./Components";
import { faTimes, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import {Container as BaseContainer} from "react-bootstrap"
import { useApp } from "../../hooks/useApp";
import { useModal } from "../../hooks/useModal";
export default function Popup({children, footer}){
    const {closeModal, openModal, modalBackTo, modalForce} = useModal();
    const {language} = useApp();
    return (
        <PopupModalContainer className={language}>
            {!modalForce && <CloseButton onClick={closeModal}><FontAwesomeIcon icon={faTimes} /></CloseButton>}
            {!modalForce && modalBackTo && <BackButton onClick={(e) => openModal(modalBackTo, false)}><FontAwesomeIcon icon={faArrowLeft} /></BackButton>}
            <BaseContainer>
                <PopupModal>
                    <PopupBody>
                        {children}
                    </PopupBody>
                    {footer && <PopupFooter>
                        {footer}
                    </PopupFooter>}
                </PopupModal>
            </BaseContainer>
        </PopupModalContainer>
    )
}